export const scrollToTop = (): void => {
  window.scrollTo(0, 0);
};

export const scrollToBottom = (element: HTMLElement | Element): void => {
  const scrollHeight = element.scrollHeight;
  element.scrollTo(0, scrollHeight);
};

export const scrollTo = (selector: string): void => {
  const offset = document.getElementById(selector).offsetTop;
  const interval = setInterval(() => {
    if (offset - document.documentElement.scrollTop < 0) {
      document.documentElement.scrollTop -= 20;
    } else {
      clearInterval(interval);
    }
  }, 5);
};

export const addDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);

  return result;
};

export const getViewportHeight = (
  numberOfElements: number,
  itemSize: number,
  margin: number
): number => {
  const maxHeight = 360;

  const result =
    numberOfElements > 0 ? numberOfElements * itemSize + margin * numberOfElements : maxHeight;

  return result > maxHeight ? maxHeight : result;
};

export const getEnumValues = (enumValue: Record<string | number, string | number>): string[] => {
  return Object.keys(enumValue).filter((item) => isNaN(Number(item)));
};

export const downloadFile = (url: string): void => {
  const link = document.createElement('a');
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
